module.exports = __webpack_public_path__ + "static/dance_1920-13c63b7c92c99364cc82a72735bf920e.jpg";